import React from 'react';
import { Eye } from 'lucide-react';
import LinksPageView from './LinksPageView';
import PhoneFrame from './PhoneFrame';

export default function LinksConfigPreview({
  restaurant,
  products,
  externalLinks,
  buttonOrder,
  theme,
  active,
}) {
  return (
    <div className="fsl-preview-col">
      <div className="fsl-preview-sticky">
        <div className="fsl-preview-head">
          <span className="fsl-preview-label">
            <Eye size={15} strokeWidth={2.4} /> Prévia ao vivo
          </span>
        </div>
        <PhoneFrame>
          <LinksPageView
            restaurant={restaurant}
            products={products}
            externalLinks={externalLinks}
            buttonOrder={buttonOrder}
            theme={theme}
            compact
          />
        </PhoneFrame>
        <p className="fsl-preview-note">
          {active
            ? 'Sua página está pública e pode ser compartilhada.'
            : 'Página pausada - os visitantes não conseguem acessá-la.'}
        </p>
      </div>
    </div>
  );
}
